import {taxActionTypes as types} from '../actions/actionTypes';

const initialState = {
  taxCodes: [],
  totalRows: 0,
};

export default function tax(state = initialState, action) {
  switch (action.type) {
    case types.LOAD_TAX_CODES_SUCCESS: {
      return {...state, taxCodes: action.taxCodes};
    }

    case types.INITIAL_LOAD:
      return {
        ...state,
        totalRows: action.payload,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/taxReducer.js